import React from 'react'
import cx from 'classnames'
import { formatPrice } from 'common/helpers'

import { Box } from 'components/_new/layout'
import { PriceWithDiscount, CrossedPrice } from 'components/_new/ui'

import s from './OldAndNewPrices.scss'


export type OldAndNewPricesProps = {
  className?: string
  newPrice: number
  oldPrice: number
  isCents?: boolean
  reverted?: boolean
  horizontalLine?: boolean
  lineUnder?: boolean
  dataTestId?: string
}


const OldAndNewPrices: React.FunctionComponent<OldAndNewPricesProps> = (props) => {
  const {
    className, newPrice, oldPrice, isCents, reverted, horizontalLine, lineUnder, dataTestId = 'oldAndNewProductPrices',
  } = props

  return (
    <span
      className={cx(className, {
        [s.reverted]: reverted,
      })}
      data-testid={dataTestId}
    >
      <PriceWithDiscount className={s.newPrice} price={formatPrice(newPrice, isCents)} />
      <Box
        tag="span"
        pl={!reverted ? 8 : null}
        pr={reverted ? 8 : null}
      >
        <CrossedPrice
          className={cx(s.oldPrice, {
            [s.lineUnder]: lineUnder,
            [s.diagonalLine]: !horizontalLine,
            [s.horizontalLine]: horizontalLine,
          })}
          price={formatPrice(oldPrice, isCents)}
        />
      </Box>
    </span>
  )
}


export default OldAndNewPrices
